import { createApp, watch, ref } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import './assets/main.css';
import '@/assets/iconfont/iconfont.css';
// import 'element-plus/es/components/loading/style/css';
import 'element-plus/es/components/message/style/css';
import "@/style/common.scss"; // common css

import "virtual:svg-icons-register"; // 公用组件插入

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);

import { router } from '@/plugins/installRouter'; // 路由注册
app.use(router);

app.mount('#vite-app');
